<template>
 <div>
  <GridIndex></GridIndex>
 </div>
</template>

<script lang = "ts" >
import GridIndex from "./components/GridUsuario.vue";
import {defineComponent} from "vue";
export default defineComponent({
 name: "BibEmprestimo",
 components: { GridIndex },
});
</script>
